<template>
    <div>
        <ValidationObserver :ref="refId"
                            tag="form"
                            class="row d-flex"
                            @submit.prevent="submit">
            <div class="col-sm-12">
                <div class="row pt-2 d-flex">
                    <div class="col-sm-3">
                        <ValidationProvider tag="div"
                                            class="mb-4"
                                            :vid="`name-${refId}`"
                                            mode="lazy"
                                            :customMessages="{required: 'Norādi dokumenta nosaukumu.'}"
                                            rules="required"
                                            v-slot="{errors}">
                            <label :for="`name-${refId}`" class="d-block text-secondary text-left mb-0">
                                Dokumenta nosaukums
                            </label>
                            <input type="text" :id="`name-${refId}`" class="w-100 py-1 ds-input" v-model="document.name">
                            <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="col-sm-2">
                        <div class="row d-flex">
                            <div class="col-sm-12">
                                <b-form-checkbox :id="`isActive-${refId}`" name="isActive" switch size="md" v-model="document.isActive">
                                    Aktīvs
                                </b-form-checkbox>
                            </div>
                        </div>
                        <div class="row pt-4 d-flex">
                            <div class="col-sm-12">
                                <b-form-checkbox :id="`isRequired-${refId}`" name="isActive" switch size="md" v-model="document.isRequired">
                                    Obligāts
                                </b-form-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-7">
                        <div class="row d-flex">
                            <div class="col-sm-4">
                                <PdfUpload @uploaded="setPdfUrl" :file="document.pdf"/>
                            </div>
                            <div class="col-sm-4">
                                <VideoUpload @uploaded="setVideoUrl" @deleted="setVideoUrl" :video="document.video" :document-id="document._id"/>
                            </div>
                            <div class="col-sm-4 text-right">
                                <CustomButton class="mt-0 mb-2 ds-btn--success"
                                              :btn-text="document._id ? 'Saglabāt' : 'Pievienot'"
                                              :is-loading="isActiveRequest"/>
                                <b-button class="ds-btn ds-btn--danger ml-1" @click="initDelete">
                                    <font-awesome-icon icon="trash"/>
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <div v-if="document.isRequired">
                    <ValidationProvider tag="div"
                                        class="mb-4 col-sm-4"
                                        :vid="`formType-${refId}`"
                                        mode="lazy"
                                        :customMessages="{required: 'Norādi dokumenta formas veidu.'}"
                                        rules="required"
                                        v-slot="{errors}">
                        <label :for="`formType-${refId}`" class="d-block text-secondary text-left mb-0">
                            Formas tips
                        </label>
                        <b-form-select :id="`formType-${refId}`"
                                       class="ds-select w-100"
                                       v-model="document.documentForm.type"
                                       :options="selectOptions"/>
                        <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <div class="col-sm-4" v-if="document.documentForm.type !== 'custom'"></div>
                    <div v-if="document.documentForm.type === 'custom'">
                        <label class="d-block text-secondary text-left mb-2">Formas jautājumi</label>
                        <div class="border px-2" style="height: 450px; overflow-y: scroll;">
                            <template v-if="document.documentForm.questions.length">
                                <div v-for="(question, i) in document.documentForm.questions" :key="question.key">
                                    <ValidationProvider tag="div"
                                                        :vid="`questionTitle-${i}-${refId}`"
                                                        mode="lazy"
                                                        :customMessages="{required: 'Norādi jautājumu!'}"
                                                        rules="required"
                                                        v-slot="{errors}">
                                        <div>
                                            <span class="mr-2">{{ i + 1 }}.</span>
                                            <textarea type="text"
                                                   class="my-2 ds-input w-75"
                                                   :name="`questionTitle-${i}-${refId}`"
                                                   placeholder="Jautājums..."
                                                   v-model="document.documentForm.questions[i].title"/>
                                            <span v-b-tooltip.hover title="Dzēst jautājumu no saraksta"
                                                  @click="document.documentForm.deleteQuestionEntry(i)">
                                        <font-awesome-icon icon="minus" class="ml-2 ds-btn--icon-red"/>
                                    </span>
                                        </div>
                                        <span class="text-danger d-block text-left small ml-4">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                    <div class="ml-4">
                                        <div v-for="(answer, j) in question.answers" :key="answer.key">
                                            <ValidationProvider tag="div"
                                                                :vid="`correctAnswer-${i}-${j}-${refId}`"
                                                                mode="lazy"
                                                                :customMessages="{
                                                            required: 'Izvēlies pareizo atbildi!',
                                                            min_value: 'Izvēlies pareizo atbildi!'
                                                        }"
                                                                rules="required|min_value:1"
                                                                v-slot="{errors}">
                                                <div>
                                                    <input type="radio"
                                                           :name="`correctAnswer-${i}-${j}-${refId}`"
                                                           class="mr-2"
                                                           :value="j + 1"
                                                           v-model="document.documentForm.questions[i].correctAnswer">
                                                    <ValidationProvider tag="span"
                                                                        :vid="`answerTitle-${i}-${j}-${refId}`"
                                                                        mode="lazy"
                                                                        :customMessages="{required: 'Norādi atbildi!'}"
                                                                        rules="required"
                                                                        v-slot="{errors}">
                                                        <input type="text"
                                                               :name="`answerTitle-${i}-${j}-${refId}`"
                                                               class="ds-input w-50 my-2"
                                                               placeholder="Atbilde..."
                                                               v-model="document.documentForm.questions[i].answers[j].title">
                                                        <span v-b-tooltip.hover title="Dzēst atbildi no saraksta"
                                                              v-if="question.answers.length > 1"
                                                              @click="question.deleteAnswerEntry(j)">
                                                    <font-awesome-icon icon="minus" class="ml-2 ds-btn--icon-red"/>
                                                </span>
                                                        <span class="text-danger d-block text-left small ml-4">{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                </div>
                                                <span class="text-danger d-block text-left small ml-4">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <span v-b-tooltip.hover title="Pievienot atbildes variantu"
                                              @click="question.addAnswerEntry()">
                                    <font-awesome-icon icon="plus" class="text-primary ds-btn--icon-grey"/>
                                </span>
                                    </div>
                                    <hr/>
                                </div>
                            </template>
                            <span v-b-tooltip.hover title="Pievienot jautājumu"
                                  @click="document.documentForm.addQuestionEntry()">
                            <font-awesome-icon icon="plus" class="text-primary mt-2 ds-btn--icon-grey"/>
                        </span>
                        </div>
                    </div>
                    <div v-if="document.documentForm.type === 'custom'" class="col-sm-12 pt-2 d-flex align-items-center">
                        <label :for="`completionAmount-${refId}`" class="d-block text-secondary text-left mb-0 mr-3">
                            Veiksmīgas izpildes jautājumu skaits
                        </label>
                        <ValidationProvider tag="div"
                                            :vid="`completionAmount-${refId}`"
                                            mode="lazy"
                                            :customMessages="{
                                                        required: 'Norādi jautājumu skaitu!',
                                                        min_value: 'Norādi vismaz 1!',
                                                        max_value: 'Nevar būt vairāk par maksimālo jautājumu skaitu'
                                                    }"
                                            :rules="{
                                        required: true,
                                        min_value: 1,
                                        max_value: document.documentForm.questions.length
                                    }"
                                            v-slot="{errors}">
                            <div class="d-flex">
                                <input type="number"
                                       class="ds-input"
                                       min="0"
                                       v-model="document.documentForm.completionAmount"
                                       :name="`completionAmount-${refId}`"
                                       :id="`completionAmount-${refId}`">
                                <span class="ml-3"> no {{ document.documentForm.questions.length }}</span>
                            </div>
                            <span class="text-danger d-block text-left small ml-4">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
            </div>
            <template v-if="document.video">
                <div class="col-sm-5">
                    <div class="row">
                        <div class="col-sm-12 pr-0">
                            <b-collapse :id="`accordion-${document.video}`" :accordion="document.video" role="tabpanel">
                                <b-card  class="p-0">
                                    <video style="width: 100%; max-height: 100%;" controls>
                                        <source :src="document.video">
                                    </video>
                                </b-card>
                            </b-collapse>
                        </div>
                    </div>
                </div>
            </template>
        </ValidationObserver>
        <hr class="my-4"/>
    </div>
</template>
<script>
    import {mapGetters, mapActions, mapMutations} from 'vuex';
    import _ from 'lodash';

    import {ValidationObserver, ValidationProvider, extend} from 'vee-validate';
    import {email, required, min_value, max_value} from 'vee-validate/dist/rules';

    import CustomButton from '@/components/global/CustomButton';
    import PdfUpload from '@/components/global/PdfUpload';
    import VideoUpload from '@/components/global/VideoUpload';
    import * as documentStoreTypes from '../../vuex/modules/document/document.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types';
    import {Document} from '../../vuex/modules/document/models/document.models';
    import * as categoryStoreTypes from '../../vuex/modules/category/category.store-types';

    export default {
        name: 'documents-form',
        components: {
            PdfUpload,
            VideoUpload,
            CustomButton,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            refId: {
                type: String,
                required: true,
            },
            documentData: {
                type: Document,
                required: true,
            },
        },
        data() {
            return {
                document: _.cloneDeep(this.documentData),
                selectOptions: [
                        {value: '', text: 'Izvēlies formas veidu'},
                        {value: 'custom', text: 'Tests'},
                        {value: 'default', text: 'Iepazīšanās'},
                    ]
            }
        },
        created() {
            extend('required', required);
            extend('email', email);
            extend('min_value', min_value);
            extend('max_value', max_value);
        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapActions('category', {
                /** @type {function|*} */
                getCategories: categoryStoreTypes.ACTION_GET_CATEGORIES,
            }),
            ...mapActions('document', {
                /** @type {function|*} */
                addDocument: documentStoreTypes.ACTION_ADD_DOCUMENT,
                /** @type {function|*} */
                updateDocument: documentStoreTypes.ACTION_UPDATE_DOCUMENT,
                /** @type {function|*} */
                removeDocument: documentStoreTypes.ACTION_REMOVE_DOCUMENT,
            }),
            async submit() {
                const isValid = await this.$refs[this.refId].validate();

                if (!isValid) {
                    return;
                }

                try {
                    if (this.document._id) {
                        await this.updateDocument({document: this.document});
                        await this.getCategories({companyId: this.$route.params.companyId});
                        return this.setAlertData({type: 'primary', message: 'Dokumenta izmaiņas saglabātas!'});
                    }

                    await this.addDocument({document: this.document});
                    await this.getCategories({companyId: this.$route.params.companyId});
                    this.setAlertData({type: 'primary', message: 'Dokuments pievienots!'});
                    this.reset();
                } catch (error) {
                    this.$refs[this.refId].setErrors({[error.field]: [error.message]});
                }
            },
            async initDelete() {
                const hasConfirmed = await this.$bvModal.msgBoxConfirm('Esi pārliecināts?', {
                    okTitle: 'Jā',
                    cancelTitle: 'Nē',
                });

                if (!hasConfirmed) {
                    return;
                }

                try {
                    if (this.document._id) {
                        await this.removeDocument({documentId: this.document._id});
                        await this.getCategories({companyId: this.$route.params.companyId});
                    }

                    this.reset();
                } catch (error) {
                    //
                }
            },
            /**
             * @param {Object} pdfData
             */
            setPdfUrl(pdfData) {
                this.document.pdf = pdfData.path;

                if (!this.document.isRequired) {
                    this.document.name = pdfData.filename.slice(0, -4);
                }
            },
            /**
             * @param {String} videoPath
             */
            setVideoUrl(videoPath) {
                this.document.video = videoPath;
            },
            reset() {
                this.$refs[this.refId].reset();
                this.$emit('finished');
            },
        },
        computed: {
            ...mapGetters('document', {
                /** @type {boolean|*} */
                isActiveRequest: documentStoreTypes.GET_IS_ACTIVE_REQUEST,
            }),
        }
    }
</script>
<style>
    .modal-xl {
        max-width: 90% !important;
    }
</style>